import { Money } from '../../money';
import { Environment } from '../../environment';
import { format, isValid } from 'date-fns';

export type AggregatedTicket = {
    liftOperatorTicketType: string;
    duration: number;
    personName: string;
    sumSales: Money;
    sumOriginalPriceSales: Money;
    sumCancellations: Money;
    sumOriginalPriceCancellations: Money;
    totalSales: number;
    totalCancellations: number;
    sumDepositAmounts: Money;
    sumCancelledDepositAmounts: Money;
    name: string;
    conditions: string[];
};

export type AggregatedTicketSearchParams = {
    userId?: string;
    orderDateFrom?: Date;
    orderDateTo?: Date;
    productionDateFrom?: Date;
    productionDateTo?: Date;
    ticketStartFrom?: Date;
    ticketStartTo?: Date;
    cancellationDateStartFrom?: Date;
    cancellationDateStartTo?: Date;
    identificationType?: string;
    environments?: Environment[];
};

// TODO: Move under lib

export const convertAggregatedTicketSearchParamsToBackend = (
    params: AggregatedTicketSearchParams
): AggregatedTicketSearchParams => {
    const backendParams: AggregatedTicketSearchParams = {};

    for (const key in params) {
        if (params[key] !== null && params[key] !== undefined) {
            if (isValid(params[key])) {
                backendParams[key] = format(params[key], 'yyyy-MM-dd');
            } else {
                backendParams[key] = params[key];
            }
        }
    }

    return backendParams;
};

type MoneyField =
    | 'sumSales'
    | 'sumCancellations'
    | 'sumDepositAmounts'
    | 'sumCancelledDepositAmounts';

export const getSumMoney = (tickets: AggregatedTicket[], key: MoneyField) =>
    tickets.map((ticket) => ticket[key]);

type AggregatedSale = Record<string, Money>;

type AggregatedTupel = [name: string, value: Money];

export const aggregatedSalesByPropName = (
    tickets: AggregatedTicket[],
    propName: 'name' | 'liftOperatorTicketType' | 'personName' | 'conditions'
): AggregatedTupel[] => {
    const aggregatedSales: AggregatedSale = tickets.reduce<AggregatedSale>(
        (sales, ticket) => {
            const field = ticket[propName];
            const fieldValue = Array.isArray(field) ? field[0] : field;

            if (fieldValue === undefined) return sales;

            sales[fieldValue as string] = {
                amount:
                    (sales[fieldValue]?.amount || 0) + ticket.sumSales.amount,
                currency: 'EUR',
            };

            return sales;
        },
        {}
    );

    const sortedByAmount: AggregatedTupel[] = Object.entries(
        aggregatedSales
    ).sort((sortA, sortB) => sortB[1].amount - sortA[1].amount);

    if (sortedByAmount.length <= 4) return sortedByAmount;

    const firstFour: AggregatedTupel[] = sortedByAmount.slice(0, 4);

    const restAggregated = sortedByAmount.slice(4, -1).reduce<AggregatedTupel>(
        (acc, [, value]) => {
            acc[1] = {
                amount: acc[1]?.amount + value.amount,
                currency: 'EUR',
            };

            return acc;
        },
        ['Sonstige', { amount: 0, currency: 'EUR' }]
    );

    return [...firstFour, restAggregated];
};
